

<div class="searchConsole" id="searchConsoleDefult" #searchConsoleDefult>
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
   <img [src]='environment1 + "assets/images/Square-T-skyblue.png"' class="t-image" alt="T">
   <div class="horizontal-line"></div>
   <div class="vertical-line"></div>
   <div class="bottom-horizontal-line"></div>
   <div class="bottom-vertical-line"></div>
    <div class="modal-content rounded-0 border-0 main-screen globalSearch-bg">
       <div class="modal-header border-0 d-flex" style="justify-content: flex-end;">
           <button id="myModal" style="height: 30px;width: 35px;" type="button" class="btn-close" id="btnclose" #btnclose (click)="goTohome()"
          ></button>
       </div>


     <div class="modal-body ps-5 pe-5">
       <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 text-white text-center">
         <div class="header-content d-grid gap-2">
           <div class="fordesktop">
           <h1 class="ad-se-fp-logo-text welcometxt">
             Welcome to
             <!-- <span class="d-block ">Tata Motors Fleet Verse</span> -->
           </h1>
           <div>
             <img [src]='environment1 + "assets/images/fleetverselogogif.gif"' class="imgpostion">
           </div>
           </div>
           <div class="ad-se-fp-logo-title mt-3">
             Search the commercial vehicle you are looking for
           </div>
         </div>
         <div class="input-search mt-5">
           <input type="text" class="form-control" placeholder="Type Tata Trucks, Tippers, Trailer, Buses, Vans, Mini Truck, Pickups or brands e.g. Ace, Intra, Yodha, Magic, Winger etc." #searchInput (keydown.enter)="enterClickData(searchInput.value)" />
         </div>
         <div class="d-sm-block mt-4">
           <button id="searchBtn" #searchBtn type="button" class="btn btn-primary btn-grad-primary"
             data-bs-target="#searchConsoleDefult2"  (click)="getSmartSearch(searchInput.value)">
             Search
           </button>
         </div>
       </div>
     </div>
   </div>
  </div>
  </div>
  <!-- <div *ngIf="listingData?.length>0" >
   <app-vehicle-mapping [listingData]="listingData"></app-vehicle-mapping>
  </div> -->
